import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import {
  Notification_Category,
  Notification_ReadState,
} from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { listNotifications } from '~/services/api/fetchers/listNotifications.api';
import { BlazeDeviceQueryKey } from '~/services/queryKeys';

export const listNotificationsQuery = (
  readStateFilter: Notification_ReadState = Notification_ReadState.UNSPECIFIED,
  categoryFilter: Notification_Category = Notification_Category.UNSPECIFIED,
  filterDeviceName = '',
) =>
  queryOptions({
    queryKey: [
      BlazeDeviceQueryKey.LIST_NOTIFICATIONS,
      readStateFilter,
      categoryFilter,
      filterDeviceName,
    ],
    queryFn: async () =>
      await listNotifications({
        readStateFilter,
        categoryFilter,
        filterDeviceName,
      }),
  });

export const listNotificationsInfiniteQuery = (
  readStateFilter: Notification_ReadState = Notification_ReadState.UNSPECIFIED,
  categoryFilter: Notification_Category = Notification_Category.UNSPECIFIED,
  filterDeviceName = '',
) =>
  infiniteQueryOptions({
    queryKey: [
      BlazeDeviceQueryKey.LIST_NOTIFICATIONS,
      'infinite',
      readStateFilter,
      categoryFilter,
      filterDeviceName,
    ],
    queryFn: async ({ pageParam }) =>
      await listNotifications({
        readStateFilter,
        categoryFilter,
        filterDeviceName,
        pageToken: pageParam,
      }),
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage.nextPageToken || undefined,
  });
